// extracted by mini-css-extract-plugin
export default {"form-header":"resultModalText_form-header__h4HMG","form-body":"resultModalText_form-body__4yBOK"};